import { BaseService, RequestType, ResponseType } from "@intech/react-service";

class FichaFinanceiraAssistido extends BaseService {
  constructor() {
    super("fichaFinanceiraAssistido");
  }

  Relatorio = (cdPlano: string, referencia: string, tipoFolha: string, especie: string, enviarPorEmail = false) =>
    this.CreateRequest<any>(RequestType.GET, `relatorio/${cdPlano}/${referencia}/${tipoFolha}/${especie}/${enviarPorEmail}`, null, ResponseType.Blob);

  BuscarDatas = (cdPlano: string) =>
    this.CreateRequest<any[]>(RequestType.GET, `datasPorPlano/${cdPlano}`);

  BuscarPorDataReferencia = (cdPlano: string, referencia: string, tipoFolha: string, especie: string) =>
    this.CreateRequest<any>(RequestType.GET, `porPlanoReferenciaTipoFolha/${cdPlano}/${referencia}/${tipoFolha}/${especie}`);

  BuscarUltimaPorPlanoProcesso = (cdPlano: string, cdEspecie: string, ano: string, num: string) =>
    this.CreateRequest<any>(RequestType.GET, `ultimaFolhaPorPlanoProcesso/${cdPlano}/${cdEspecie}/${ano}/${num}`);

}

export const FichaFinanceiraAssistidoService = new FichaFinanceiraAssistido();
